import {Placeholder, ToolbarGroup} from '@wordpress/components';
import {BlockControls, useBlockProps} from '@wordpress/block-editor';
import {__} from "@wordpress/i18n";
import Inspector from "./inspector";

export const edit = (props) => {
	const {attributes, setAttributes, isSelected} = props;
	const blockProps = useBlockProps();

	const {color} = attributes;

	return (
		<div {...blockProps}>
			<BlockControls>
				<ToolbarGroup/>
			</BlockControls>

			<Inspector
				attributes={attributes}
				setAttributes={setAttributes}
			/>

			<div style={{padding: "20px", color: color}}>
				{__('Title property', 'realpress')}
			</div>
		</div>

	);
}

